module.exports = __webpack_public_path__ + "img/passleft.002fce43.png";